
import React from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";
import { Check } from "lucide-react";

interface BookingCancelledDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export function BookingCancelledDialog({ isOpen, onClose }: BookingCancelledDialogProps) {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-2">
            <div className="p-2 rounded-full bg-green-100">
              <Check className="h-6 w-6 text-green-600" />
            </div>
            <AlertDialogTitle>Meeting Cancelled</AlertDialogTitle>
          </div>
          <AlertDialogDescription>
            Your meeting has been successfully cancelled. All participants have been notified.
            <p className="mt-2 text-sm text-muted-foreground">
              You should also receive a calendar cancellation email shortly.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={onClose}>Close</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
